import React, { useEffect, useState } from 'react';
import DataTable, { DataTableColumn } from '../Components/DataTable';
import { ExtFixtureItem } from './FixtureOverviewModels';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import RoundOverviewUtil from '../RoundOverview/RoundOverviewUtil';
import { green, yellow } from '@material-ui/core/colors';
import { Box, Button, Link } from '@material-ui/core';
import { Link as RouterLink } from "react-router-dom";

interface ExtFixtureTableProps {
    items: ExtFixtureItem[];
    onSelect? : (item : ExtFixtureItem) => void;
    onMap? : (item : ExtFixtureItem) => void;
    ngMode?: boolean;
}

const ExtFixtureTable: React.FC<ExtFixtureTableProps> = (props) => {
    const [selectedId, setSelectedId] = useState<string>("");
    const [columns, setColumns] = useState<DataTableColumn<ExtFixtureItem>[]>([]);
    const [ngColumns, setNgColumns] = useState<DataTableColumn<ExtFixtureItem>[]>([]);
 
    useEffect(() => {
      refreshColumns();
    }, []);
    
    const refreshColumns = () => {
      var cols: DataTableColumn<ExtFixtureItem>[] = [
        { id: 'id', numeric: false, disablePadding: true, label: "Id", filterEnabled: true },
        { id: 'providerId', numeric: false, disablePadding: true, label: "Provider", filterEnabled: true },
        { id: 'extId', numeric: false, disablePadding: true, label: "Ext Id", filterEnabled: true },
        { id: 'name', numeric: false, disablePadding: false, label: 'Ext name', filterEnabled: true },
        { id: 'startingAt', numeric: false, disablePadding: false, label: 'Ext Starting at', filterEnabled: true, renderValue: it => CreateRoundUtil.toGameDateString(it.startingAt) },
        // { id: 'status', numeric: false, disablePadding: false, label: 'Ext Status', filterEnabled: true, renderValue: it => renderExtStatus(it) },
        { id: 'mappingId', numeric: false, disablePadding: false, label: 'Mapping Id', filterEnabled: true },
        { id: 'mappingStatus', numeric: false, disablePadding: false, label: 'Mapping status', renderValue: it => renderMappingStatus(it) },
        { id: 'mappingReversed', numeric: false, disablePadding: false, label: 'Reversed' },
        { id: 'fixtureId', numeric: false, disablePadding: false, label: 'Fixture Id', filterEnabled: true },
        { id: 'fixtureName', numeric: false, disablePadding: false, label: 'Fixture name' },
        { id: 'fixtureStartingAt', numeric: false, disablePadding: false, label: 'Fixture Starting at', renderValue: it => CreateRoundUtil.toGameDateString(it.fixtureStartingAt) },
        { id: 'leagueName', numeric: false, disablePadding: false, label: 'League' },
        { id: 'fixtureStatus', numeric: false, disablePadding: false, label: 'Fixture status', filterEnabled: true },
      ];
      var ngCols: DataTableColumn<ExtFixtureItem>[] = [
        { id: 'id', numeric: false, disablePadding: true, label: "Id", filterEnabled: true },
        { id: 'providerId', numeric: false, disablePadding: true, label: "Provider", filterEnabled: true },
        { id: 'extId', numeric: false, disablePadding: true, label: "Ext Id", filterEnabled: true },
        { id: 'name', numeric: false, disablePadding: false, label: 'Ext name', filterEnabled: true },
        { id: 'startingAt', numeric: false, disablePadding: false, label: 'Ext Starting at', filterEnabled: true, renderValue: it => CreateRoundUtil.toGameDateString(it.startingAt) },
        { id: 'fixtureNgId', numeric: false, disablePadding: false, label: 'FixtureNg Id', filterEnabled: true, renderValue: renderFixtureNgId },
        { id: 'fixtureNgName', numeric: false, disablePadding: false, label: 'FixtureNg name' },
        { id: 'fixtureNgStartingAt', numeric: false, disablePadding: false, label: 'FixtureNg Starting at', renderValue: it => CreateRoundUtil.toGameDateString(it.fixtureStartingAt) },
        { id: 'competitionNgName', numeric: false, disablePadding: false, label: 'CompetitionNg' },
        { id: 'countryNgName', numeric: false, disablePadding: false, label: 'CountryNg' },
        { id: 'sportNgName', numeric: false, disablePadding: false, label: 'SportNg' },
      ];

      setColumns(cols);
      setNgColumns(ngCols);
    }
    // const renderExtStatus = (item : ExtFixtureItem) : string => {
    //   var statusName = item.status;
    //   if (item.extStatus && item.extStatus.length > 0) {
    //     statusName += ` (${item.extStatus})`;
    //   }
    //   return statusName;
    // };
    const renderMappingStatus = (item : ExtFixtureItem) : any => {
      var statusName = item.mappingStatus;
      var color : string | undefined = undefined;
      if (item.mappingId && item.mappingId > 0) {
        color = RoundOverviewUtil.VALID_COLOR;
      } else if (statusName) {
        switch (statusName) {
          case "EXACT_MATCH":
            color = yellow[500];
            break;
          default:
            color = RoundOverviewUtil.INVALID_COLOR;
            break;
        }
      }
      if (color) {
        var content : any = null;
        if (item.fixtureId && props.onMap) {
          content = (<Link component={Button} onClick={e => onMap(item)}>{statusName}</Link>);
        } else {
          content = statusName;
        }
        return (
          <Box bgcolor={color}>{content}</Box>
        );
      }
      return statusName;
    };
    const renderReversed = (item : ExtFixtureItem) : any => {
      if (item.mappingReversed) {
        return (
          <Box bgcolor={RoundOverviewUtil.INVALID_COLOR}>X</Box>
        );
      } else if (item.mappingReversed === undefined) {
        return null;
      }
      return "-";
    };
    const renderFixtureNgId = (item : ExtFixtureItem) : any => {
      var color : string | undefined = undefined;
      if (item.fixtureNgId && item.fixtureNgId > 0) {
        color = RoundOverviewUtil.VALID_COLOR;
      }
      if (color) {
        var content : any = null;
        if (item.fixtureNgId && props.onMap) {
          content = (<Link component={Button} onClick={e => onMap(item)}>{item.fixtureNgId}</Link>);
          return (
            <Box bgcolor={color}>{content}</Box>
          );
        }
      }
      return item.fixtureNgId;
    };
    const onSelect = (item : ExtFixtureItem) => {
        setSelectedId(item.extId);
        if (props.onSelect){
          props.onSelect(item);
        }
    };
    const onMap = (item : ExtFixtureItem) => {
      if (props.onMap){
        props.onMap(item);
      }
    };
    var cols = props.ngMode === true ? ngColumns : columns;
    return (
      <DataTable columns={cols} items={props.items} getId={it => it.extId} orderBy='startingAt' order='asc' resultFilterEnabled={true} size='xsmall' onSelect={onSelect}  />
    );
  };
  
  export default ExtFixtureTable;
 